import LocalForage from '../../../app/localForage'
import { S3CheckinEntry } from '../../../app/types'
import useAppDispatch from '../../../hooks/useAppDispatch'
import { setS3EntriesUpdatedForOfflineUse } from '../../data/dataSlice'
import { setSnackbarMessages } from '../../snackbar/snackbarSlice'

const useUpdateLocalForageEntries = () => {
  const dispatch = useAppDispatch()

  const updateLocalForageEntries = async (eventId: number, entries: S3CheckinEntry[]) => {
    const localForage = LocalForage.instance()

    const browserStorageEntries = await localForage.get<S3CheckinEntry>('entries', eventId)
    if (browserStorageEntries?.length) {
      await localForage.remove('entries', eventId)
    }

    const stored = await localForage.set('entries', eventId, entries)
    if (stored) {
      dispatch(
        setSnackbarMessages({
          messageLines: [
            {
              message: `EventID: ${eventId} entries have been successfully stored for offline access`
            },
          ],
          severity: 'success',
        })
      )
      dispatch(setS3EntriesUpdatedForOfflineUse(true))
    } else {
      dispatch(
        setSnackbarMessages({
          messageLines: [
            {
              message: `Data cannot be stored in browser due to its storage capacity. 
                You will have to re-fetch your data from the server after closing the browser`,
            },
          ],
          severity: 'warning',
        })
      )
      dispatch(setS3EntriesUpdatedForOfflineUse(false))
    }
  }

  return updateLocalForageEntries
}

export default useUpdateLocalForageEntries
